import { useContext, useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import AuthContext from "../../../context/auth/AuthContext";
import { getPushNotification } from "../../../services/push-notifications";
import { getPushJobPollingInterval } from "../../../helpers/push-notifications";
import { pushNotificationKeys } from "../queryKeys";

const usePushNotificationJob = (jobId) => {
  const { tenant } = useContext(AuthContext);
  const tenantCode = tenant?.code;
  const openedAt = useRef(Date.now());

  return useQuery({
    queryKey: pushNotificationKeys.job(tenantCode, jobId),
    queryFn: ({ signal }) => getPushNotification({ jobId, signal }),
    enabled: Boolean(tenantCode && jobId),
    refetchInterval: (query) =>
      getPushJobPollingInterval(query.state.data, Date.now() - openedAt.current),
    refetchIntervalInBackground: false,
  });
};

export default usePushNotificationJob;
